import $ from 'jquery'

let $window = $(window)

export default () => {
    let images = getImages()

    if (images.length === 0) {
        setImagesLoaded()
        return
    }

    images.forEach((el) => {
        if (!shouldLoadOnPageLoad(el)) {
            return
        }

        if (isElementLoadingLazy(el)) {
            el.removeAttribute('loading');
        }

        let image = new Image()
        image.onload = onImageEvent
        image.onerror = onImageEvent
        image.src = el.src
    })
}

function getImages() {
    return $('img').toArray()
}

function onImageEvent (e) {
    let complete = true

    getImages().forEach((el) => {
        if (shouldLoadOnPageLoad(el) && !el.complete) {
            complete = false
        }
    })

    $window.trigger('imageLoaded', [e, complete])

    if (complete) {
        setImagesLoaded()
    }
}

function shouldLoadOnPageLoad(element) {
    return isElementInViewport(element) || !isElementLoadingLazy(element)
}

function isElementLoadingLazy(element) {
    return element.hasAttribute('loading') && element.getAttribute('loading') === 'lazy'
}

export function isElementInViewport(element) {
    let bounding = element.getBoundingClientRect()
    let elementHeight = element.offsetHeight
    let elementWidth = element.offsetWidth

    return bounding.top >= -elementHeight &&
        bounding.left >= -elementWidth &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + elementWidth &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elementHeight
}

function setImagesLoaded()
{
    $('body').data('imagesLoaded', true)
    $window.trigger('imagesLoaded')
}

export function isImagesLoaded()
{
    return $('body').data('imagesLoaded') === true
}
